import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FlexGrid, GridPanel, CellType, CellRange, CellRangeEventArgs, SelectionMode } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';
import { FlexGridFilter } from '@grapecity/wijmo.grid.filter';
import * as wjcCore from '@grapecity/wijmo';

import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { ClassCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1400Model } from '../kymw1400/kymw1400.model';
import { KYMW1404Model } from './kymw1404.model';
import { KYMW1404InputModel } from './vo/kymw1404-input.model';
import { KYMW1404OutPutModel } from './vo/kymw1404-output.model';
import { SellingAreaListModel } from '../kymw1400/vo/selling-area-list.model';
import { NominationGoodsDataModel } from '../kymw1400/vo/nomination-goods-data.model';

import { KYMW1405Component } from '../kymw1405/kymw1405.component';

import { GetNominationGoodsDataService } from './api-services/get-nomination-goods-data.service';
import { GetSellingAreaService } from './api-services/get-selling-area.service';
import {
  OrderNumQuotaCodeComboBoxComponent
} from '../../../commons/kymw02/combo-box/order-num-quota-code-combo-box/order-num-quota-code-combo-box.component';
import { CheckboxLabelComponent } from 'src/app/commons/kymw02/checkbox-label/checkbox-label.component';
import { NominationGoodsSearchConditionModel } from './vo/nomination-goods-search-condition.model';

/**
 * 掲載候補商品リスト画面を管理するクラス
 *
 * @export KYMW1404Component
 * @class KYMW1404Component
 */
@Component({
  selector: 'app-kymw1404',
  templateUrl: 'kymw1404.component.html',
  styleUrls: ['kymw1404.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1404Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('cmb_OrderGoodsFlg', { static: true }) cmb_OrderGoodsFlg: CodeComboBoxComponent;
  @ViewChild('cmb_SellAreaName', { static: true }) cmb_SellAreaName: ElementRef;
  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('cmb_OrderNumQuota', { static: true }) cmb_OrderNumQuota: OrderNumQuotaCodeComboBoxComponent;
  @ViewChild('dtg_NominationGoodsList', { static: true }) dtg_NominationGoodsList: FlexGrid;
  @ViewChild('flr_NominationGoodsList', { static: true }) flr_NominationGoodsList: FlexGridFilter;
  @ViewChild('chb_NotPublishFlg', { static: true }) chb_NotPublishFlg: CheckboxLabelComponent;
  @ViewChild('chb_WPublishFlg', { static: true }) chb_WPublishFlg: CheckboxLabelComponent;
  @ViewChild('btn_Search', { static: true }) btn_Search: ElementRef;
  @ViewChild('closebtn', { static: true }) closebtn: ElementRef;

  /**
   * 受渡情報ＶＯ
   */
  public inputVO: KYMW1404InputModel = null;

  /**
   * DataGridの列名とテーブル物理名を紐付ける連想配列Object
   */
  private tableName: Object = null;

  public closeFunction: Function = null;
  public setKYMW1404Parameter: Function = null;
  public kymw1404Model: KYMW1404Model = null;

  // コンテキストメニュー
  public contextMenu: Menu = null;

  // 選択行変更フラグ
  private selectChangeFlg = Boolean(false);
  // グリッド初期表示フラグ
  private gridInitFlag = Boolean(true);

  /**
   *Creates an instance of KYMW1404Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {ElementRef} elementRef
   * @param {KYMW00Model} kymw00Model
   * @param {KYMW1400Model} kymw1400Model
   * @param {GetNominationGoodsDataService} getNominationGoodsDataService
   * @param {GetSellingAreaService} getSellingAreaService
   * @memberof KYMW1404Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private elementRef: ElementRef,
    private kymw00Model: KYMW00Model,
    private kymw1400Model: KYMW1400Model,
    private getNominationGoodsDataService: GetNominationGoodsDataService,
    private getSellingAreaService: GetSellingAreaService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1404Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1404';

    this.tableName = new Object();
    this.tableName['Arranged'] = 'Arranged';
    this.tableName['WPublish'] = 'WPublish';
    this.tableName['OrderCodeDiff'] = 'OrderCodeDiff';
    this.tableName['GuideGoodsName'] = 'GuideGoodsName';
    this.tableName['GuideStandardName'] = 'GuideStandardName';
    this.tableName['ClassName'] = 'ClassNameKanji';
    this.tableName['MiddleClassName'] = 'MiddleClassNameKanji';
    this.tableName['SmallClassName'] = 'SmallClassNameKanji';
    this.tableName['GuideTempZoneName'] = 'GuideTempZoneName';
    this.tableName['PlanNum'] = 'PlanNum';
    this.tableName['PlanPrice'] = 'PlanPrice';
    this.tableName['Gpr'] = 'Gpr';
    this.tableName['Pcode'] = 'PCode';
    this.tableName['PricePattern'] = 'PricePattern';
    this.tableName['BuyerComment'] = 'BuyerComment';
    this.tableName['RelateMasterCode'] = 'RelateMasterCode';
    this.tableName['EnableIbaraki'] = 'EnableIbaraki';
    this.tableName['EnableTochigi'] = 'EnableTochigi';
    this.tableName['EnableGunma'] = 'EnableGunma';
    this.tableName['EnableChiba'] = 'EnableChiba';
    this.tableName['EnableSaitama'] = 'EnableSaitama';
    this.tableName['EnableTokyo'] = 'EnableTokyo';
    this.tableName['EnableNagano'] = 'EnableNagano';
    this.tableName['EnableNiigata'] = 'EnableNiigata';
    this.tableName['MarkCode'] = 'MarkCode';
    this.tableName['ThisTimeSupplyPrice'] = 'ThisTimeSupplyPrice';
    this.tableName['OrderNum'] = 'OrderNum';

    this.initLoad();

    // フォーカス
    this.cmb_OrderGoodsFlg.comboBox.nativeElement.focus();
  }

  /**
   * 画面初期処理
   *
   * @memberof KYMW1404Component
   */
  private initLoad() {
    this.kymw1404Model.kymw1404Component = this;
    let changeFlg = false;
    if (this.kymw1404Model.coopCode !== this.inputVO.coopCode
      || this.kymw1404Model.pageNum !== this.inputVO.pageNum
      || this.kymw1404Model.activeKomaFlag !== this.inputVO.activeKomaFlag) {
      changeFlg = true;
    }

    // 明細行の使用可否設定
    this.kymw1404Model.editMode = this.inputVO.editMode;

    // アクティブコマの有無を変更
    // 検索条件をmanageに設定し、メニュー表示時に判定
    this.kymw1404Model.activeKomaFlag = this.inputVO.activeKomaFlag;

    // 検索区分
    this.kymw1404Model.processDiv = this.inputVO.processDiv;

    // 再検索フラグがＯＮまたは検索条件が変更されている場合
    if (this.kymw1404Model.processDiv === 2 || this.isChangeInputParam() === true) {
      setTimeout(() => {
        this.plessEnabledSetting();
      });

      if (this.isChangeInputParam() === true) {
        this.kymw1404Model.sellingAreaArray = new Array<any>();
        this.kymw1404Model.nominationGoodsArray = new Array<any>();

        this.cmb_ClassCode.selectedIndex = 0;
        this.kymw1404Model.chkNotPublish = true;
        this.kymw1404Model.chkWPublish = false;
        this.kymw1404Model.orderCodeOrderNumQuota = '';
        this.kymw1404Model.mediumTypeOrderNumQuota = '';

        this.kymw1404Model.sellAreaCode = '';
        this.kymw1404Model.classCode = '';
        this.kymw1404Model.orderNumQuota = '';
        this.kymw1404Model.wPubilshFlg = 0;
        this.kymw1404Model.notPublishFlg = 1;

        this.kymw1404Model.searchValueChangeFlag = true;
      } else {
        this.kymw1404Model.searchValueChangeFlag = false;

        // 前回検索条件表示
        this.reDraw();
      }

      // 検索条件をmanageに設定
      this.kymw1404Model.orderCode = this.inputVO.orderCode;
      this.kymw1404Model.mediumType = this.inputVO.mediumType;
      this.kymw1404Model.coopCode = this.inputVO.coopCode;
      this.kymw1404Model.pageNum = this.inputVO.pageNum;
      this.kymw1404Model.orderGoodsFlg = this.inputVO.orderGoodsFlg;
      this.cmb_OrderGoodsFlg.setCodeValue(this.inputVO.orderGoodsFlg);
      this.cmb_OrderGoodsFlg.selectedCodeValue = this.inputVO.orderGoodsFlg;
      this.cmb_ClassCode.orderCode = this.inputVO.orderCode;

      this.kymw1404Model.dutiesFormDiv = this.inputVO.dutiesFormDiv;

      // 「いつでも注文商品」を選択時は「売り場」「W掲載予定商品のみ」「注文コード割当」を非活性にする
      if (this.inputVO.orderGoodsFlg === '02') {
        // 売り場
        this.kymw1404Model.disabledSellAreaName = true;
        // W掲載予定商品
        this.kymw1404Model.disabledWPublishFlg = true;
        // 注文コード割当
        this.kymw1404Model.disabledOrderNumQuota = true;
      } else if (this.inputVO.orderGoodsFlg === '01') {
        // 売り場
        this.kymw1404Model.disabledSellAreaName = false;
        // W掲載予定商品
        this.kymw1404Model.disabledWPublishFlg = false;
        // 注文コード割当
        this.kymw1404Model.disabledOrderNumQuota = false;
      }

      // 業態区分スポットの場合は注文商品区分、W掲載予定商品のチェックを非活性にする
      if (this.inputVO.dutiesFormDiv === '3') {
        // 注文商品区分
        this.kymw1404Model.disabledOrderGoodsFlg = true;
        // W掲載予定商品
        this.kymw1404Model.disabledWPublishFlg = true;
      } else {
        // 業態区分ウィークリー、デイリー、期間の活性処理
        // （W掲載予定商品チェックボックスは注文商品区分で設定した活性/非活性を変更しない）

        // 注文商品区分
        this.kymw1404Model.disabledOrderGoodsFlg = false;
      }

      // 再検索フラグがＯＮの場合は、一旦直前の情報を表示後、検索を行う。
      if (this.kymw1404Model.processDiv === 2) {
        // 検索結果をクリア
        this.kymw1404Model.clear();
      }

      // 媒体区分が設定されている場合のみコンボボックスを設定する
      if (!PlessViewUtilsSub.isEmpty(this.kymw1404Model.mediumType) &&
        !PlessViewUtilsSub.isEmpty(this.kymw1404Model.orderCode)) {
        if (this.kymw1404Model.searchValueChangeFlag === true) {
          // イベントを発行し、「売り場」コンボボックスを設定
          const sellingAreaListVO: SellingAreaListModel = new SellingAreaListModel();
          sellingAreaListVO.mediumType = this.kymw1404Model.mediumType;

          this.getSellingAreaService.execute(this.kymw1404Model, sellingAreaListVO);

          if (this.inputVO.orderCode === '' || this.inputVO.mediumType === '') {
            this.kymw1404Model.orderCodeOrderNumQuota = '';
            this.kymw1404Model.mediumTypeOrderNumQuota = '';
          } else {
            this.kymw1404Model.orderCodeOrderNumQuota = this.inputVO.orderCode;
            this.kymw1404Model.mediumTypeOrderNumQuota = this.inputVO.mediumType;
          }

          this.kymw1404Model.orderNumQuotaIdx = 0;
        }

        if (this.kymw1404Model.showFirstOrderNumCombo === true) {

          if (this.inputVO.orderCode === '' || this.inputVO.mediumType === '') {
            this.kymw1404Model.orderCodeOrderNumQuota = '';
            this.kymw1404Model.mediumTypeOrderNumQuota = '';
          } else {
            this.kymw1404Model.orderCodeOrderNumQuota = this.inputVO.orderCode;
            this.kymw1404Model.mediumTypeOrderNumQuota = this.inputVO.mediumType;
          }

          this.kymw1404Model.showFirstOrderNumCombo = false;
        }

        // 検索処理を実行
        this.dispatcherSearchEvent(null, false);
      }

      // ALL CLEAR
      if (this.inputVO.orderCode === '' || this.inputVO.mediumType === '') {
        this.kymw1404Model.sellingAreaArray = new Array<any>();
        this.cmb_ClassCode.selectedIndex = 0;
        this.kymw1404Model.chkNotPublish = true;
        this.kymw1404Model.chkWPublish = false;
        this.kymw1404Model.orderCodeOrderNumQuota = '';
        this.kymw1404Model.mediumTypeOrderNumQuota = '';

        this.kymw1404Model.sellAreaCode = '';
        this.kymw1404Model.classCode = '';
        this.kymw1404Model.wPubilshFlg = 0;
        this.kymw1404Model.notPublishFlg = 1;

        this.setColorPattern();
      }
    } else {
      // 再検索フラグがＯＦＦ(コマ割画面へ貼り付け後でない)、かつ検索条件の変更なしの場合は再検索しない
      if (this.kymw1404Model.coopCode !== this.inputVO.coopCode) {
        this.kymw1404Model.page = 1;
        this.kymw1404Model.searchValueChangeFlag = true;
      } else {
        this.kymw1404Model.searchValueChangeFlag = false;
      }

      this.kymw1404Model.orderCode = this.inputVO.orderCode;
      this.kymw1404Model.mediumType = this.inputVO.mediumType;
      this.kymw1404Model.coopCode = this.inputVO.coopCode;
      this.kymw1404Model.pageNum = this.inputVO.pageNum;
      this.kymw1404Model.orderGoodsFlg = this.inputVO.orderGoodsFlg;
      this.kymw1404Model.dutiesFormDiv = this.inputVO.dutiesFormDiv;

      // 検索処理を実行
      if (changeFlg) {
        this.dispatcherSearchEvent('now', false);
      }
    }

    // グリッド初期処理
    if (this.gridInitFlag) {
      this.gridInit();
      this.gridInitFlag = false;
    }
    this.selectChangeFlg = true;
    this.dtg_NominationGoodsList.select(-1, -1);

    // コンテキストメニュー設定
    this.setContextMenu();

    // グリッドのフィルタ設定
    if (!PlessViewUtilsSub.isEmpty(this.kymw1404Model.filterStatus)) {
      this.flr_NominationGoodsList.filterDefinition = this.kymw1404Model.filterStatus;
    }
    // グリッドのソート設定
    if (!PlessViewUtilsSub.isEmpty(this.kymw1404Model.sortStatus) && !PlessViewUtilsSub.isEmptyArray(this.kymw1404Model.sortStatus)) {
      if (this.dtg_NominationGoodsList.collectionView) {
        this.dtg_NominationGoodsList.collectionView.sortDescriptions.push(new wjcCore.SortDescription(this.kymw1404Model.sortStatus[0].property, this.kymw1404Model.sortStatus[0].ascending));
      }
    }

    // グリッドの活性制御
    setTimeout(() => {
      this.setNominationGoodsListEnabled();
    });
  }
  /**
   * グリッド初期処理
   *
   * @private
   * @memberof KYMW1404Component
   */
  private gridInit(): void {
    this.dtg_NominationGoodsList.itemsSourceChanged.addHandler((sender, e) => {
      this.applyBackgroundColor(sender, e);
    });
    this.dtg_NominationGoodsList.formatItem.addHandler((sender, e) => {
      this.applyBackgroundColor(sender, e);
    });

    // Mousedownよりも先に処理される
    this.dtg_NominationGoodsList.selectionChanging.addHandler((s, e: CellRangeEventArgs) => {
      if (e.row > -1) {
        // 選択行変更フラグが立っていない場合は選択をキャンセル
        // 行押下時では、セル選択状態がついてしまうため、
        // Mousedownイベントにて処理された場合のみ、選択処理を実施させる
        if (!this.selectChangeFlg) {
          // 選択処理のキャンセル
          e.cancel = true;
        }
        this.selectChangeFlg = false;
      }
    });

    // グリッドの行押下時(mousedown)
    this.dtg_NominationGoodsList.hostElement.addEventListener('mousedown', (e: MouseEvent) => {
      if (e.button === 0) {  // 左クリック
        const ht = this.dtg_NominationGoodsList.hitTest(e);

        // セルクリックのみ処理を実施
        if (ht.cellType === CellType.Cell) {

          // Ctrl + Click、Shift + Clickでもない場合、
          // 行単位で選択を実施（列選択を行わせない）
          // Ctrl の押されていない、Shift + Clickが来た場合は、
          // 現在選択値の行から、押下された行までを選択（列選択は行わせない）
          if (!e.ctrlKey && !e.shiftKey) {
            if (this.dtg_NominationGoodsList.rows[ht.row].isSelected === false) {
              this.dtg_NominationGoodsList.select(-1, -1);
              this.selectChangeFlg = true;
              this.dtg_NominationGoodsList.select(ht.row, -1);
            }
          } else if (!e.ctrlKey && e.shiftKey) {
            let row;
            if (this.dtg_NominationGoodsList.selection.col2 === -1) {
              row = this.dtg_NominationGoodsList.selection.row2;
            } else {
              row = this.dtg_NominationGoodsList.selection.row;
            }
            this.selectChangeFlg = true;
            this.dtg_NominationGoodsList.select(new CellRange(ht.row, -1, row, -1), -1);
          } else {
            if (this.dtg_NominationGoodsList.rows[ht.row].isSelected) {
              this.selectChangeFlg = true;
            } else {
              this.selectChangeFlg = true;
              this.dtg_NominationGoodsList.rows[ht.row].isSelected = true;
            }
          }
        }
      }
    });

    // ドラッグ開始イベント
    this.flr_NominationGoodsList.grid.hostElement.addEventListener('dragstart', (e: DragEvent) => {
      const ht = this.flr_NominationGoodsList.grid.hitTest(e);
      this.kymw1400Model.goodsItem = this.flr_NominationGoodsList.grid.collectionView.items[ht.row];
    });

    // ドラッグ終了イベント
    this.flr_NominationGoodsList.grid.hostElement.addEventListener('dragend', (e: DragEvent) => {
      this.kymw1400Model.goodsItem = null;
      this.eventCandidateGoodsList_DRAGCOMPLETEHandler(e);
    });

    // ダブルクリックイベント
    this.dtg_NominationGoodsList.hostElement.addEventListener('dblclick', (e: DragEvent) => {
      this.eventCandidateGoodsList_ITEMDOUBLECLICKHandler(e);
    });

    // ドラッグ制御
    this.dtg_NominationGoodsList.itemFormatter = (panel: GridPanel, r: number, c: number, cell: HTMLElement) => {
      if (panel.cellType === CellType.ColumnHeader) {
        // ヘッダーはドラッグ禁止
        cell.draggable = false;
      } else if (panel.cellType === CellType.Cell) {
        // セルのスタイル設定
        if (this.kymw1404Model.nominationGoodsArray != null) {  // リストにデータが存在する際
          // 掲載候補商品リスト選択可か
          if (this.inputVO.editMode === '0') {
            // ホバー用クラス追加
            cell.classList.add('wj-custom-cell');
            // ドラッグ可
            cell.draggable = true;
          }
        } else {  // リストにデータが存在しない
          // ドラッグ禁止
          cell.draggable = false;
        }
      }
    };

    // フィルタ・ソート 設定
    if (this.flr_NominationGoodsList) {
      this.flr_NominationGoodsList.filterChanged.addHandler(
        (f: FlexGridFilter) => {
          // フィルタ変更時にフィルタ状態を保持
          this.kymw1404Model.filterStatus = this.flr_NominationGoodsList.filterDefinition;
          // ソート状態を保持
          this.kymw1404Model.sortStatus = this.dtg_NominationGoodsList.collectionView.sortDescriptions.map(
            function (sortDesc) {
              return { property: sortDesc.property, ascending: sortDesc.ascending };
            }
          );
        }
      )
    }
  }

  public applyBackgroundColor(sender: any, e: any): void {
    this.dtg_NominationGoodsList.select(-1, -1);
    // 背景色設定
    this.dtg_NominationGoodsList.rows.forEach((row) => {
      const pubCnt = Number(row.dataItem.PublishCnt);
      const otherMedTypFlg: string = row.dataItem.OtherMediumTypeFlg;
      const wPublish: string = row.dataItem.WPublish;
      const parentCnt = Number(row.dataItem.ParentCnt);

      // 掲載済み商品が1件以上
      if (pubCnt >= 1) {
        // 自媒体選定商品
        if (otherMedTypFlg === '0') {
          if (PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trim(wPublish))) {
            // 掲載済み＋自媒体選定商品の場合：掲載済み商品(ピンク)を設定
            row.cssClass = 'grid-row-pink';
          } else {
            if (pubCnt === 1) {
              // W掲載の親コマが既に配置されているかチェック
              if (parentCnt === 1) {
                // 掲載済＋自媒体選定商品＋Ｗ掲載予定＋Ｗ掲載親コマ配置済：イエローを設定
                row.cssClass = 'grid-row-yellow';
              } else {
                // 掲載済み(1件）＋自媒体選定商品＋Ｗ掲載予定＋Ｗ掲載親コマ未配置：未掲載のＷ掲載予定(緑)を設定
                row.cssClass = 'grid-row-green';
              }
            } else if (pubCnt >= 2) {
              // Ｗ掲載の親コマが既に配置されているかチェック
              if (parentCnt === 1) {
                // 掲載済み(2件以上）＋自媒体選定商品＋Ｗ掲載予定＋Ｗ掲載親コマ配置済：掲載済み商品(ピンク)を設定
                row.cssClass = 'grid-row-pink';
              } else {
                // 掲載済み(2件以上）＋自媒体選定商品＋Ｗ掲載予定＋Ｗ掲載親コマ未配置：掲載済み商品(ピンク)を設定
                row.cssClass = 'grid-row-green';
              }
            }
          }
        } else {
          // 他媒体選定商品
          // Ｗ掲載予定商品
          if (PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trim(otherMedTypFlg))) {
            // 掲載済み＋他媒体選定商品の場合：掲載済み商品(ピンク)を設定
            row.cssClass = 'grid-row-pink';
          } else {
            // 掲載済み＋他媒体選定商品＋Ｗ掲載予定の場合：掲載済み商品(ピンク)を設定
            row.cssClass = 'grid-row-pink';
          }
        }
      } else {
        // 未掲載商品
        // 自媒体選定商品
        if (otherMedTypFlg === '0') {
          // Ｗ掲載予定商品
          if (PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trim(wPublish))) {
            // 未掲載＋自媒体選定商品の場合：デフォルト(白)を設定
            row.cssClass = 'grid-row-white';
          } else {
            // 未掲載＋自媒体選定商品＋Ｗ掲載予定の場合：未掲載のＷ掲載予定(緑)を設定
            row.cssClass = 'grid-row-green';
          }
        } else {
          // 他媒体選定商品
          // Ｗ掲載予定商品
          if (PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trim(wPublish))) {
            // 未掲載＋他媒体選定商品の場合：他媒体の選定商品(オレンジ)を設定
            row.cssClass = 'grid-row-orange';
          } else {
            // Ｗ掲載の親コマが既に配置されているかチェック
            if (parentCnt === 1) {
              // 未掲載＋他媒体選定商品＋Ｗ掲載予定＋Ｗ掲載親配置の場合：イエローを設定
              row.cssClass = 'grid-row-yellow';
            } else {
              // 未掲載＋他媒体選定商品＋Ｗ掲載予定の場合：未掲載のＷ掲載予定(緑)を設定
              row.cssClass = 'grid-row-green';
            }
          }
        }
      }
    });
  }
  /**
   * パラメータ設定処理
   *
   * @param {KYMW1404InputModel} inputVO
   * @memberof KYMW1404Component
   */
  public inputParameterSetting(): void {
    this.inputVO = this.iInputVOArray;
  }

  /**
   * パラメータ設定処理
   *
   * @param {KYMW1404InputModel} inputVO
   * @memberof KYMW1404Component
   */
  public setInputVO(inputVO: KYMW1404InputModel): void {
    // コマ割り画面から再表示を行う
    this.inputVO = inputVO;
    // this.ngOnInit();
    this.initLoad();
  }

  /**
   * コンテキストメニューを追加
   *
   * @memberof KYMW1404Component
   */
  setContextMenu(): void {
    this.contextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { header: 'コマ配置', caption: 'コマ配置', cmd: 'SetKoma', enabled: true },
          { header: 'アクティブなコマに配置', caption: 'アクティブなコマに配置', cmd: 'SetActiveKoma', enabled: true },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenu.selectedValue) {
            case 'SetKoma':
              this.eventKomaArrangeMent_CONTEXTCLICKHandler();
              break;
            case 'SetActiveKoma':
              this.eventActiveKomaArrangeMent_CONTEXTCLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_NominationGoodsList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        // コンテキストメニューの活性非活性制御
        this.eventContextMenu_MENUSELECTHandler(this.contextMenu);
        // メニュー表示
        this.contextMenu.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[0], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[1], 'none');
  }

  /**
   * コンテキストメニュー項目活性・非活性制御
   *
   * @returns {*}
   * @memberof KYMW1404Component
   */
  public getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * 終了ボタンクリック時イベント
   *
   * @memberof KYMW1404Component
   */
  public eventBtnEndCLICKHandler(): void {
    this.kymw1404Model.showFirstOrderNumCombo = true;

    this.closeWindow();
  }

  /**
   * 画面終了
   *
   * @memberof KYMW1404Component
   */
  public closeWindow(): void {
    // フィルタ状態を消去
    this.kymw1404Model.filterStatus = '';
    // ソート状態を消去
    this.kymw1404Model.sortStatus = null;

    this.closeFunction();
  }

  /**
   * 「注文商品区分」コンボボックスを変更した時に呼び出されるメソッド。
   *
   * @memberof KYMW1404Component
   */
  public eventOrderGoodsFlg_CHANGEHandler(): void {
    // 「掲載候補商品一覧」の表示を、選択している「注文商品区分」「売り場」「部門」「注文コード割当」
    // 「W掲載予定商品のみ」（チェック時のみ）「未掲載商品のみ」（チェック時のみ）に該当する商品企画情報に絞り込む
    // managerに検索条件をセット
    // 注文商品区分
    const orderGoodsFlg: string = this.cmb_OrderGoodsFlg.selectedCodeValue;

    // データ取得処理を実施
    this.kymw1404Model.processDiv = 1;
    this.dispatcherSearchEvent();

    // 「いつでも注文商品」を選択時は「売り場」「W掲載予定商品のみ」「注文コード割当」を非活性にする
    if (orderGoodsFlg === '02') {
      // 売り場
      this.kymw1404Model.disabledSellAreaName = true;
      // W掲載予定商品
      this.kymw1404Model.disabledWPublishFlg = true;
      // 注文コード割当
      this.kymw1404Model.disabledOrderNumQuota = true;
    } else if (orderGoodsFlg === '01') {
      // 売り場
      this.kymw1404Model.disabledSellAreaName = false;
      // W掲載予定商品
      this.kymw1404Model.disabledWPublishFlg = false;
      // 注文コード割当
      this.kymw1404Model.disabledOrderNumQuota = false;
    }
  }

  /**
   * 「売り場」コンボボックスを変更した時に呼び出されるメソッド。
   *
   * @memberof KYMW1404Component
   */
  public eventSellAreaName_CHANGEHandler(): void {
    // managerに検索条件をセット
    const i: number = this.cmb_SellAreaName.nativeElement.selectedIndex;

    if (i > 0) {
      this.kymw1404Model.sellAreaCode = this.kymw1404Model.cmbSellingAreaList[(i - 1)].SellAreaCode;
    } else {
      // 未選択または空行を選択している場合はコードをクリア
      this.kymw1404Model.sellAreaCode = '';
    }

    // データ取得処理を実施
    this.kymw1404Model.processDiv = 1;
    this.dispatcherSearchEvent();

    this.kymw1404Model.searchValueChangeFlag = true;
  }

  /**
   * 「部門」コンボボックスを変更した時に呼び出されるメソッド。
   *
   * @memberof KYMW1404Component
   */
  public eventClassCode_CHANGEHandler(): void {
    // managerに検索条件をセット
    // 部門コード
    this.kymw1404Model.classCode = this.cmb_ClassCode.selectedClassCode;

    // データ取得処理を実施
    this.kymw1404Model.processDiv = 1;
    this.dispatcherSearchEvent();
  }

  /**
   * 注文コード割当コンボボックス変更時イベント
   *
   * @memberof KYMW1404Component
   */
  public eventOrderNumQuota_CHANGEHandler(): void {
    this.kymw1404Model.orderNumQuota = this.cmb_OrderNumQuota.selectedOrderNumQuotaCode;
    this.kymw1404Model.orderNumQuotaIdx = this.cmb_OrderNumQuota.selectedIndex;

    // データ取得処理を実施
    this.kymw1404Model.processDiv = 1;
    this.dispatcherSearchEvent();
  }

  /**
   * 「Ｗ掲載予定商品のみ」チェックボックスを変更した時に呼び出されるメソッド。
   *
   * @memberof KYMW1404Component
   */
  public eventWPublishFlg_CLICKHandler(): void {
    // managerに検索条件をセット
    if (this.kymw1404Model.chkWPublish === true) {
      this.kymw1404Model.wPubilshFlg = 1;
    } else {
      this.kymw1404Model.wPubilshFlg = 0;
    }

    // データ取得処理を実施
    this.kymw1404Model.processDiv = 1;
    this.dispatcherSearchEvent();
  }

  /**
   * 「未掲載商品のみ」チェックボックスを変更した時に呼び出されるメソッド。
   *
   * @memberof KYMW1404Component
   */
  public eventNotPublishFlg_CHANGEHandler(): void {
    // managerに検索条件をセット
    if (this.kymw1404Model.chkNotPublish === true) {
      this.kymw1404Model.notPublishFlg = 1;
    } else {
      this.kymw1404Model.notPublishFlg = 0;
    }

    // データ取得処理を実施
    this.kymw1404Model.processDiv = 1;
    this.dispatcherSearchEvent();
  }

  /**
   * 「前へ」ボタンを押下した時に呼び出されるメソッド
   *
   * @memberof KYMW1404Component
   */
  public eventBtnBack_CLICKHandler(): void {
    // 保持しているページカウンタを-1する
    this.kymw1404Model.page = this.kymw1404Model.page - 1;

    // データ取得処理を実施
    this.kymw1404Model.processDiv = 1;
    this.dispatcherSearchEvent('back');

    this.kymw1404Model.searchValueChangeFlag = true;
  }

  /**
   * コンテキストメニュー「コマ配置」を選択した時のイベント
   *
   * @private
   * @memberof KYMW1404Component
   */
  public eventKomaArrangeMent_CONTEXTCLICKHandler(): void {
    // 一覧で選択中の行数を設定
    this.setSelItemCnt();

    // 選択データを「コマ割」画面へ返却する。(複数行選択されていた場合は全データ返却)
    this.createSelectData(event, false, 1);
  }

  /**
   * コンテキストメニュー「アクティブなコマに配置」を選択した時のイベント
   *
   * @private
   * @memberof KYMW1404Component
   */
  public eventActiveKomaArrangeMent_CONTEXTCLICKHandler(): void {
    // 一覧で選択中の行数を設定
    this.setSelItemCnt();

    // 選択データを「コマ割」画面へ返却する。(複数行選択されていた場合は全データ返却)
    this.createSelectData(event, false, 2);
  }

  /**
   * データグリッドの右クリック時のイベント
   *
   * @private
   * @param {Menu} contextMenu コンテキストメニュー
   * @memberof KYMW1404Component
   */
  public eventContextMenu_MENUSELECTHandler(contextMenu: Menu): void {
    let enableFlag = Boolean(true);
    if (this.dtg_NominationGoodsList.selection.row === -1
      || this.dtg_NominationGoodsList.selectionMode === SelectionMode.None) {
      enableFlag = false;
    }
    // ユーザの権限を取得
    const readOnly: boolean = this.kymw00Model.kymw1001Model.topFuncReadOnlyMode;

    contextMenu.itemsSource.forEach(item => {
      // 閲覧ユーザの場合はメニューを非活性
      if (readOnly) {
        enableFlag = false;
      } else if (item.caption === 'アクティブなコマに配置' && this.kymw1404Model.activeKomaFlag === 0) {
        // 「コマ割」画面でコマが未選択の場合は「アクティブなコマに配置」を非活性
        enableFlag = false;
      }
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  /**
   * データグリッドのドラッグ＆ドロップ時のイベント
   *
   * @private
   * @param {DragEvent} event
   * @memberof KYMW1404Component
   */
  public eventCandidateGoodsList_DRAGCOMPLETEHandler(event: DragEvent): void {
    // 一覧で選択中の行数を設定
    this.setSelItemCnt();

    // 「コマ割」画面へイベントの完了通知を行う。
    // 選択データはFlexの機能を使用し、受渡を行っている。
    this.createSelectData(event, true, 3);
  }

  /**
   * データグリッドでダブルクリックが発生した際のイベント
   *
   * @private
   * @param {*} event
   * @memberof KYMW1404Component
   */
  public eventCandidateGoodsList_ITEMDOUBLECLICKHandler(event: any): void {

    // ヘッダー内部がクリックされている場合は何もしない
    if (this.dtg_NominationGoodsList.hitTest(event).cellType === CellType.ColumnHeader              // カラムヘッダーである、
      || this.dtg_NominationGoodsList.hitTest(event).edgeLeft                                                // 左端、
      || this.dtg_NominationGoodsList.hitTest(event).edgeRight) {                                            // 右端の場合
      // 判定結果を返却
      return;
    }

    // 一覧で選択中の行数を設定
    this.setSelItemCnt();

    // 選択データを「コマ割」画面へ返却する。(複数行選択されていた場合は先頭データのみ返却)
    this.createSelectData(event, true, 1);
  }

  /**
   * 検索ボタンを押下した時に呼び出されるメソッド。
   *
   * @memberof KYMW1404Component
   */
  public eventSearch_CLICKHandler(): void {
    // 「部門」コンボボックスのデータを設定
    this.kymw1404Model.cmbClassCodeList = this.cmb_ClassCode.model.classList;
    // 「掲載候補商品検索」画面を起動
    const componentRef = this.dialogService.openModal(KYMW1405Component);
    const instance = componentRef.componentInstance as KYMW1405Component;
    instance.parent = this;
    instance.kymw1404Model = this.kymw1404Model;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 遷移元からの受渡情報の変更有無を確認する
   *
   * @private
   * @returns {Boolean} true 変更あり/false 変更なし
   * @memberof KYMW1404Component
   */
  private isChangeInputParam(): boolean {
    // 受渡情報とManagerを比較し、変更があれば、初期化を行う
    if (this.kymw1404Model.orderCode !== this.inputVO.orderCode) {
      return true;
    } else if (this.kymw1404Model.mediumType !== this.inputVO.mediumType) {
      return true;
    }
    return false;
  }

  /**
   * 掲載候補商品リストのデータ取得イベントを発行する
   *
   * @param {String} [paging=null] 呼び出し画面判定フラグ(true:自画面の場合、false:コマ割画面の場合)
   * @param {Boolean} [selfEvent=true]
   * @returns {void}
   * @memberof KYMW1404Component
   */
  public dispatcherSearchEvent(paging: string = null, selfEvent = true): void {

    // 受渡項目の必須チェックでエラーの場合は以降の処理を行わない
    if (this.checkRequiredParam() === false) {
      // 検索結果をクリア
      this.kymw1404Model.clear();

      return;
    }


    // 検索結果をクリア
    this.kymw1404Model.clear();

    // 検索条件をVOにセット
    const searchVO = new NominationGoodsSearchConditionModel();
    searchVO.formID = 'KYMW1404';
    searchVO.orderCode = this.kymw1404Model.orderCode;
    searchVO.mediumType = this.kymw1404Model.mediumType;
    searchVO.coopCode = this.kymw1404Model.coopCode;
    searchVO.pageNum = this.kymw1404Model.pageNum;
    searchVO.sellAreaCode = this.kymw1404Model.sellAreaCode;
    searchVO.classCode = this.kymw1404Model.classCode;
    searchVO.orderNumQuota = this.kymw1404Model.orderNumQuota;
    searchVO.classCodeArray = this.kymw1404Model.classCodeArray;
    searchVO.wPubilshFlg = this.kymw1404Model.wPubilshFlg;
    searchVO.notPublishFlg = this.kymw1404Model.notPublishFlg;
    searchVO.guideGoodsName = this.kymw1404Model.guideGoodsName;
    searchVO.pcodeList = this.kymw1404Model.pcodeList;
    searchVO.otherMediumTypeFlg = this.kymw1404Model.otherMediumTypeFlg;
    searchVO.sortItem = this.kymw1404Model.sortItem;
    searchVO.sortOrder = this.kymw1404Model.sortOrder;
    searchVO.page = this.kymw1404Model.page;
    searchVO.orderGoodsFlg = this.cmb_OrderGoodsFlg.selectedCodeValue;
    searchVO.dutiesFormDailyList = this.kymw1404Model.dutiesFormDailyList;

    this.getNominationGoodsDataService.execute(this.kymw1404Model, searchVO);

  }

  /**
   * 受渡項目の必須チェック
   *
   * @private
   * @returns {Boolean}
   * @memberof KYMW1404Component
   */
  private checkRequiredParam(): boolean {
    if (PlessViewUtilsSub.isEmpty(this.kymw1404Model.orderCode)) {
      return false;
    } else if (PlessViewUtilsSub.isEmpty(this.kymw1404Model.mediumType)) {
      return false;
    } else if (PlessViewUtilsSub.isEmpty(this.kymw1404Model.coopCode)) {
      return false;
    }
    return true;
  }

  /**
   * manageのデータで再表示
   *
   * @memberof KYMW1404Component
   */
  public reDraw(): void {
    // 売り場コンボボックス
    const sellAreaAry: Array<any> = this.kymw1404Model.cmbSellingAreaList;
    for (let i = Number(0); i < sellAreaAry.length; i++) {
      if (this.kymw1404Model.sellAreaCode === sellAreaAry[i].SellAreaCode) {
        this.cmb_SellAreaName.nativeElement.selectedIndex = i + 1;
        break;
      }
    }

    // 部門コンボボックス
    this.cmb_ClassCode.setClassCode(this.kymw1404Model.classCode);

    // 注文コード割当コンボボックス
    this.cmb_OrderNumQuota.selectedIndex = this.kymw1404Model.orderNumQuotaIdx;

    // W掲載予定商品のみチェックボックス
    if (this.kymw1404Model.wPubilshFlg === 1) {
      this.kymw1404Model.chkWPublish = true;
    } else {
      this.kymw1404Model.chkWPublish = false;
    }

    // 未掲載商品のみチェックボックス
    if (this.kymw1404Model.notPublishFlg === 1) {
      this.kymw1404Model.chkNotPublish = true;
    } else {
      this.kymw1404Model.chkNotPublish = false;
    }
    // 背景色を設定
    this.setColorPattern();

  }

  /**
   * 一覧の背景色を設定
   *
   * @memberof KYMW1404Component
   */
  public setColorPattern(): void {
    const dataList: Array<any> = this.kymw1404Model.nominationGoodsArray;

    const colorCode: Object = new Object();
    colorCode['White'] = getComputedStyle(document.documentElement).getPropertyValue('--koma-backgroundcolor-white');
    colorCode['Pink'] = getComputedStyle(document.documentElement).getPropertyValue('--koma-backgroundcolor-Pink');
    colorCode['Orange'] = getComputedStyle(document.documentElement).getPropertyValue('--koma-backgroundcolor-Orange');
    colorCode['Green'] = getComputedStyle(document.documentElement).getPropertyValue('--koma-backgroundcolor-Green');
    colorCode['Yellow'] = getComputedStyle(document.documentElement).getPropertyValue('--koma-backgroundcolor-Yellow');

    const colorAry: Array<any> = [];
    let listCnt = Number(0);
    if (dataList != null) {
      listCnt = dataList.length;
    }

    let colorKey = String('White');
    for (let i = Number(0); i < listCnt; i++) {
      const pubCnt: number = dataList[i].PublishCnt;
      const otherMedTypFlg: string = dataList[i].OtherMediumTypeFlg;
      const wPublish: string = dataList[i].WPublish;
      const parentCnt: number = dataList[i].ParentCnt;

      // 掲載済み商品が1件以上
      if (pubCnt >= 1) {
        // 自媒体選定商品
        if (otherMedTypFlg === '0') {
          if (PlessViewUtilsSub.isEmpty(wPublish)) {
            // 掲載済み＋自媒体選定商品の場合：掲載済み商品(ピンク)を設定
            colorKey = 'Pink';
          } else {
            if (pubCnt === 1) {
              // W掲載の親コマが既に配置されているかチェック
              if (parentCnt === 1) {
                // 掲載済＋自媒体選定商品＋Ｗ掲載予定＋Ｗ掲載親コマ配置済：イエローを設定
                colorKey = 'Yellow';
              } else {
                // 掲載済み(1件）＋自媒体選定商品＋Ｗ掲載予定＋Ｗ掲載親コマ未配置：未掲載のＷ掲載予定(緑)を設定
                colorKey = 'Green';
              }
            } else if (pubCnt >= 2) {
              // Ｗ掲載の親コマが既に配置されているかチェック
              if (parentCnt === 1) {
                // 掲載済み(2件以上）＋自媒体選定商品＋Ｗ掲載予定＋Ｗ掲載親コマ配置済：掲載済み商品(ピンク)を設定
                colorKey = 'Pink';
              } else {
                // 掲載済み(2件以上）＋自媒体選定商品＋Ｗ掲載予定＋Ｗ掲載親コマ未配置：掲載済み商品(ピンク)を設定
                colorKey = 'Green';
              }
            }
          }
        } else {      // 他媒体選定商品
          // Ｗ掲載予定商品
          if (PlessViewUtilsSub.isEmpty(otherMedTypFlg)) {
            // 掲載済み＋他媒体選定商品の場合：掲載済み商品(ピンク)を設定
            colorKey = 'Pink';
          } else {
            // 掲載済み＋他媒体選定商品＋Ｗ掲載予定の場合：掲載済み商品(ピンク)を設定
            colorKey = 'Pink';
          }
        }
      } else {    // 未掲載商品
        // 自媒体選定商品
        if (otherMedTypFlg === '0') {
          // Ｗ掲載予定商品
          if (PlessViewUtilsSub.isEmpty(wPublish)) {
            // 未掲載＋自媒体選定商品の場合：デフォルト(白)を設定
            colorKey = 'White';
          } else {
            // 未掲載＋自媒体選定商品＋Ｗ掲載予定の場合：未掲載のＷ掲載予定(緑)を設定
            colorKey = 'Green';
          }
        } else {      // 他媒体選定商品
          // Ｗ掲載予定商品
          if (PlessViewUtilsSub.isEmpty(wPublish)) {
            // 未掲載＋他媒体選定商品の場合：他媒体の選定商品(オレンジ)を設定
            colorKey = 'Orange';
          } else {
            // Ｗ掲載の親コマが既に配置されているかチェック
            if (parentCnt === 1) {
              // 未掲載＋他媒体選定商品＋Ｗ掲載予定＋Ｗ掲載親配置の場合：イエローを設定
              colorKey = 'Yellow';
            } else {
              // 未掲載＋他媒体選定商品＋Ｗ掲載予定の場合：未掲載のＷ掲載予定(緑)を設定
              colorKey = 'Green';
            }
          }
        }
      }

      // 背景色を設定
      colorAry.push(colorCode[colorKey]);
    }
  }

  /**
   * 明細部の活性/非活性の設定を行う
   *
   * @private
   * @memberof KYMW1404Component
   */
  private setNominationGoodsListEnabled(): void {
    const cells = this.elementRef.nativeElement.querySelector('.wj-cells');
    if (this.kymw1404Model.editMode === '1') {
      // 非活性にする
      // Grid選択不可
      this.dtg_NominationGoodsList.selectionMode = SelectionMode.None;
      // 選択不可状態
      cells.classList.add('wj-cells-disabled');
    } else {
      // 活性にする
      // Grid 複数行選択可
      this.dtg_NominationGoodsList.selectionMode = SelectionMode.ListBox;

      // 選択可状態へCSSを変更
      cells.classList.remove('wj-cells-disabled');
    }
  }

  /**
   * 選択中のＰコードを生成し、｢コマ割｣画面へ返却する
   *
   * @private
   * @param {Event} event
   * @param {boolean} singleSelFlg
   * @param {number} processDiv
   * @returns {void}
   * @memberof KYMW1404Component
   */
  private createSelectData(event: Event, singleSelFlg: boolean, processDiv: number): void {
    let tmpVO: NominationGoodsDataModel = null;

    // 一覧がロック状態の場合は処理しない
    if (this.inputVO.editMode === '1') {
      return;
    }

    const ary: Array<any> = this.dtg_NominationGoodsList.selectedItems;
    const outAry: Array<any> = new Array<any>();

    // 1件のみ返却する場合
    if (singleSelFlg) {
      // selectedItemsのソート順が一定でないため、現在の一覧データと比較し、最初に一致するデータを返却する
      const showAry: Array<any> = this.kymw1404Model.nominationGoodsArray;
      let breakFlg:boolean = false;
      for (let i = Number(0); i < showAry.length; i++) {
        // 選択されている行のＰコード
        for (let j = Number(0); j < ary.length; j++) {
          if (showAry[i].Pcode === ary[j].Pcode
            && showAry[i].OrderNum === ary[j].OrderNum
            && showAry[i].ItemCode === ary[j].ItemCode
            && showAry[i].StartOrderCode === ary[j].StartOrderCode) {
            tmpVO = new NominationGoodsDataModel();
            tmpVO.pcode = ary[j].Pcode;
            tmpVO.orderNum6Digits = ary[j].OrderNum;
            tmpVO.itemCode = ary[j].ItemCode;
            tmpVO.receiptSOrderCode = ary[j].ReceiptSOrderCode;
            tmpVO.startOrderCode = ary[j].StartOrderCode;
            tmpVO.orderGoodsFlg = this.cmb_OrderGoodsFlg.selectedCodeValue;
            outAry.push(tmpVO);
            breakFlg = true;
            break;
          }
        }
        if (breakFlg) break;
      }
    } else {
      // 選択されている行のＰコードをリスト化
      for (let k = Number(0); k < ary.length; k++) {
        tmpVO = new NominationGoodsDataModel();
        tmpVO.pcode = ary[k].Pcode;
        tmpVO.orderNum6Digits = ary[k].OrderNum;
        tmpVO.itemCode = ary[k].ItemCode;
        tmpVO.receiptSOrderCode = ary[k].ReceiptSOrderCode;
        tmpVO.startOrderCode = ary[k].StartOrderCode;
        tmpVO.orderGoodsFlg = this.cmb_OrderGoodsFlg.selectedCodeValue;
        outAry.push(tmpVO);
      }
    }
    // VOにセット
    const outputVO: KYMW1404OutPutModel = new KYMW1404OutPutModel();
    outputVO.processDiv = processDiv;
    outputVO.goodsData = outAry;
    // 親画面にPコードのリストを返却する
    this.parent.setKYMW1404Parameter(outputVO);
  }

  /**
   * 一覧で選択中のデータ件数をmanagerへ設定
   *
   * @returns {void}
   * @memberof KYMW1404Component
   */
  public setSelItemCnt(): void {
    // 一覧がロック状態の場合は処理しない
    if (this.inputVO.editMode === '0') {
      return;
    }
    // 一覧で選択中のデータを取得
    const selArray: Array<any> = this.dtg_NominationGoodsList.selectedItems;
    if (selArray === null) {
      this.kymw1404Model.pasteCnt = 0;
    } else {
      this.kymw1404Model.pasteCnt = selArray.length;
    }
  }

  /**
   * ウィンドウ内のドラッグ制御
   *
   * @param {*} event
   * @memberof KYMW1404Component
   */
  onDragstartBody(event: any): void {
    /* ウインドウ操作を阻害しないようにイベントを無効化し、伝播をキャンセルする */
    if (event.srcElement.className.indexOf('wj-cell') === -1) {
      event.preventDefault();   // イベントを無効化
      event.stopPropagation();  // 上位へのイベントの伝播をキャンセル
    } else {
      event.stopPropagation();  // 上位へのイベントの伝播をキャンセル
    }
  }

  /**
   * 活性・非活性制御処理
   *
   * @memberof KYMW0800Component
   */
  plessEnabledSetting() {
  }

  /**
   * タブキーによるフォーカス先制御
   */
  public tabkey_focusEventHandler(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    if (event.key !== 'Tab') {
      return;
    }
    if (event.shiftKey) {
      // 逆行
      switch (target.id) {
        case 'cmb_SellAreaName':
          // 「注文商品区分」にフォーカスが当たるようにする
          this.cmb_OrderGoodsFlg.comboBox.nativeElement.focus();
          event.preventDefault();
          break;
        case 'chb_WPublishFlg_sub':
          // 「注文コード割当」にフォーカスが当たるようにする
          this.cmb_OrderNumQuota.comboBox.nativeElement.focus();
          event.preventDefault();
          break;
        case 'cmb_ClassCode_sub':
          // 「掲載商品」にフォーカスが当たるようにする
          this.chb_NotPublishFlg.checkbox.nativeElement.focus();
          event.preventDefault();
          break;
        case 'btn_Search':
          // 「部門」にフォーカスが当たるようにする
          this.cmb_ClassCode.setFocus();
          event.preventDefault();
          break;
        case 'closebtn':
          // 「検索」ボタンにフォーカスが当たるようにする
          this.btn_Search.nativeElement.focus();
          event.preventDefault();
          break;
      }
      return;
    }
    // 順行
    switch (target.id) {
      case 'cmb_OrderGoodsFlg_sub':
        // 「売り場」にフォーカスが当たるようにする
        this.cmb_SellAreaName.nativeElement.focus();
        event.preventDefault();
        break;
      case 'cmb_OrderNumQuota_sub':
        // 「掲載商品」にフォーカスが当たるようにする
        this.chb_WPublishFlg.checkbox.nativeElement.focus();
        event.preventDefault();
        break;
      case 'chb_NotPublishFlg_sub':
        // 「部門」にフォーカスが当たるようにする
        this.cmb_ClassCode.setFocus();
        event.preventDefault();
        break;
      case 'cmb_ClassCode_sub':
        // 「検索」ボタンにフォーカスが当たるようにする
        this.btn_Search.nativeElement.focus();
        event.preventDefault();
        break;
      case 'btn_Search':
        // 「閉じる」にフォーカスが当たるようにする
        this.closebtn.nativeElement.focus();
        event.preventDefault();
        break;
    }
  }
}
